// STATIC ROUTES FOR POSSIBLE PROVIDER SLUGS
//
// populate using:
// 		select distinct '`' || provider_slug || '`,' as prov from provider order by prov asc;
//
// Use a diff/merge tool to merge the query results with this page.
//
// This includes all possible providers slugs, not enabled providers;
// such that we can match possible provider routes statically and not do a wildcard search and runtime lookup
// a new provider will not be accessible on the website until it is added to this list.
//
// This is reasonable both as a precaution against enabling a new provider until reviewed but also
// because we need to add a provider logo to the CDN.
//
// Adding routes at runtime does not work (tested).
//
export const gameProviderRoutes = [
    `1x2gaming`,
    `3oaks`,
    `4theplayer`,
    `adlunam`,
    `asia-gaming`,
    `atomic-slot-lab`,
    `avatarux`,
    `aviator`,
    `aviatrix`,
    `bang-bang-games`,
    `belatra-games`,
    `betgames`,
    `betnow`,
    `betsoft`,
    `bgaming`,
    `big-time-gaming`,
    `bigpot-gaming`,
    `blue-guru`,
    `blueprint-gaming`,
    `boominggames`,
    `bulletproof-games`,
    `cq9slot`,
    `edgelabs`,
    `electric-elephant`,
    `endorphina`,
    `evolution`,
    `evoplay`,
    `expanse-studios`,
    `ezugi`,
    `fantasma`,
    `fbastards`,
    `felt`,
    `flush-originals`,
    `fomo-originals`,
    `four-leaf-gaming`,
    `galaxsys`,
    `gameart`,
    `games-global`,
    `gametech`,
    `gamevy`,
    `gamingcorps`,
    `gamomat-games`,
    `habanero`,
    `hacksaw-gaming`,
    `high-5-games`,
    `hissho-dragon`,
    `hot-rise-games`,
    `iconic21`,
    `indigomagic`,
    `irondog`,
    `islesoft`,
    `jaderabbit`,
    `jellypirates`,
    `jili-games`,
    `justslots`,
    `lady-luck-games`,
    `live-solutions`,
    `live88`,
    `manna-play`,
    `max-win-gaming`,
    `mg-live`,
    `microgaming`,
    `microgaming-live`,
    `million-games`,
    `netent`,
    `netgaming`,
    `nolimit-city`,
    `northern-lights-gaming`,
    `novomatic`,
    `octoplay`,
    `oddin`,
    `onetouch`,
    `originals`,
    `oryx-gaming`,
    `penguinking`,
    `peter-and-sons`,
    `pgsoft`,
    `phoenix7`,
    `pinoy-bet-games`,
    `play-n-go`,
    `playace`,
    `playson`,
    `playtech`,
    `playtech-live`,
    `playzia`,
    `popiplay`,
    `pragmatic-play`,
    `pragmatic-play-live`,
    `print-studios`,
    `prospectgaming`,
    `push-gaming`,
    `quickspin`,
    `quik`,
    `ready-play-gaming`,
    `red-tiger-gaming`,
    `reelkingdom`,
    `reelplay`,
    `reflex-gaming`,
    `relax-gaming`,
    `rocketbet-originals`,
    `rogue-gaming`,
    `rubyplay`,
    `sgaming`,
    `shadylady`,
    `silverback-gaming`,
    `skillex`,
    `skywind`,
    `skywind-live`,
    `slingo`,
    `slot-factory`,
    `slotgarten`,
    `slotmill`,
    `solvited`,
    `spinomenal`,
    `storm-gaming`,
    `sweepnow`,
    `thunderkick`,
    `tomhorn`,
    `topspin`,
    `trigger`,
    `twainsport`,
    `updown`,
    `wazdan`,
    `winfast`,
    `yggdrasil-gaming`
];
export const isGameProviderRoute = (slug) => gameProviderRoutes.includes(slug);
